import { cloneDeep } from '@/utils/utils'

const REFEREES_DECISION = {
  WIN: 'WIN',
  DRAW: 'DRAW',
  UNKNOWN: 'UNKNOWN'
}

let refereesDecision = REFEREES_DECISION.UNKNOWN

function setGamerCondition (event) {
  const { extra, EventCode } = event
  const { getIngameData, currentSportEvents } = this
  const { gamerCondition } = getIngameData

  const value = cloneDeep(gamerCondition)

  value[extra.team === 1 ? 'home' : 'away'] = {
    eventCode: EventCode,
    title: currentSportEvents[EventCode].title
  }

  this.setIngameProperty({
    property: 'gamerCondition',
    value
  })
}

export default {
  // 'this' - $store
  byActionType: {
  },
  // 'this' - $store
  byEventType: {
    'GAMER_CONDITION_HEADACHE' (event) {
      setGamerCondition.call(this, event)
    },
    'GAMER_CONDITION_HIGH_TEMPERATURE' (event) {
      setGamerCondition.call(this, event)
    },
    'GAMER_CONDITION_INTOXICATION' (event) {
      setGamerCondition.call(this, event)
    },
    'GAMER_CONDITION_NORMAL' (event) {
      setGamerCondition.call(this, event)
    },
    'GAMER_CONDITION_TILT' (event) {
      setGamerCondition.call(this, event)
    },
    'MATCH_FORMAT' (event) {
      const { extra } = event
      const {
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat: firstVersionTimerFormats,
        has_golden_set: hasGoldenSet,
        inverse,
        timerSpeedUp,
        is_shootout_series_format: isShootoutSeriesFormat,
        has_tackles: hasTackles,
        weight_class: weightClass
      } = extra
      const timerFormat = !firstVersionTimerFormats
        ? {
          inverse,
          resetEachPeriod: true
        }
        : firstVersionTimerFormats

      this.setMatchFormat({
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat,
        timerSpeedUp,
        has_golden_set: hasGoldenSet,
        has_tackles: hasTackles
      })

      this.setIngameProperty({
        property: 'weightClass',
        value: weightClass
      })

      if (!isShootoutSeriesFormat) return

      this.setShootoutSeriesFormat()
    },
    'WIN' () {
      refereesDecision = REFEREES_DECISION.WIN
    },
    'DRAW' () {
      refereesDecision = REFEREES_DECISION.DRAW
    }
  },
  // 'this' - tradermode component instance
  // для кастомной логики отображения event
  eventTitles: {
    'FINISH_GAME' (event) {
      const {
        TeamNumber
      } = event

      const {
        homeTeamTitle,
        awayTeamTitle
      } = this

      if (refereesDecision === REFEREES_DECISION.DRAW) {
        return `${this.$t('trader.gameover')} / ${this.$t('trader.draw.referees')}`
      }

      if (refereesDecision === REFEREES_DECISION.WIN) {
        return `${this.$t('trader.gameover')} / ${this.$t('trader.win.referees')} ${TeamNumber === 1 ? homeTeamTitle : awayTeamTitle}`
      }

      return this.$t('trader.gameover')
    }
  },
  eventClasses: {
  }
}
